module.exports = __webpack_public_path__ + "3f16e137/img/copy-icon.408fdb2d.svg";